export const SESSION_CONFIG = {
  TIMELINE_MAX: 50,
  HEARTBEAT_INTERVAL_MS: 15 * 60 * 1000,
  SESSION_TTL_MS: 3 * 60 * 60 * 1000, // align with server TTL
  MAX_EVENTS_PER_BATCH: 50,
  MAX_BATCH_BYTES: 800_000, // keep well under API limit
} as const;

/**
 * Get the current app version from environment variables.
 * Uses NEXT_PUBLIC_RELEASE or NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA as fallback.
 */
export const getAppVersion = (): string | undefined =>
  typeof process !== 'undefined'
    ? process.env.NEXT_PUBLIC_RELEASE ||
      process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA ||
      undefined
    : undefined;
